/* The collapsed "Basis and limits" disclosure. Tokens only (ADR-0007). */

.disclosure > summary {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  cursor: pointer;
  font-size: var(--t-dense);
  font-weight: 600;
  color: var(--accent);
}

.disclosure > summary:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.disclosure > summary:active {
  color: var(--ink);
}

.disclosure > summary:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 3px;
  border-radius: 3px;
}

.disclosure[open] > summary {
  margin-bottom: 10px;
}

.disclosure[open] > summary svg {
  transform: rotate(90deg);
}

.body {
  display: grid;
  gap: 8px;
  max-width: 78ch;
  font-size: var(--t-min);
  line-height: 1.55;
  color: var(--ink-2);
}

.body p {
  margin: 0;
}
